export const getWelcomeMessage = (
  firstname: string | null,
  username: string | null
): string => {
  const time = new Date().getHours();
  let prefix = "";
  if (time < 12) {
    prefix = "Good morning";
  } else if (time < 18) {
    prefix = "Good afternoon";
  } else {
    prefix = "Good evening";
  }

  if (firstname || username) {
    return `${prefix}, ${firstname && firstname !== "" ? firstname : username}`;
  } else {
    return prefix;
  }
};
